var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.039 85.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #6d6e71;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .st1 {\n        stroke: #ed1c24;\n      }\n\n      .st2 {\n        fill: #ed1c24;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 41.102,
    y1: 48.189,
    x2: 2.835,
    y2: 48.189
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 41.102,
    y1: 51.024,
    x2: 2.835,
    y2: 51.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 43.937,
    y1: 48.189,
    x2: 41.102,
    y2: 48.189
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 43.937,
    y1: 51.024,
    x2: 41.102,
    y2: 51.024
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 82.205,
    y1: 48.189,
    x2: 43.937,
    y2: 48.189
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 82.205,
    y1: 51.024,
    x2: 43.937,
    y2: 51.024
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.122,44.933c-.036-.103-.078-.203-.126-.3l2.693-1.322c.098.2.185.408.261.621l-2.828,1.001ZM39.923,44.945l-2.834-.986c.075-.216.162-.425.262-.628l2.695,1.318c-.047.096-.088.194-.123.295ZM44.176,43.645c-.086-.065-.177-.125-.27-.179l1.512-2.591c.195.114.383.238.563.374l-1.805,2.396ZM40.863,43.652l-1.816-2.388c.178-.136.365-.261.559-.376l1.526,2.582c-.093.056-.184.116-.27.181ZM42.684,43.099c-.098-.005-.198-.006-.298,0l-.196-2.994.044-.002c.206-.01.409-.009.611.001l-.161,2.995Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinished);
export default __webpack_public_path__ + "static/media/finished.0fe8c8a522e0ebfb282292682d0a0dd8.svg";
export { ForwardRef as ReactComponent };